/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const VirusScanStatus = {
    Pending: 'Pending',
    Clean: 'Clean',
    Threat: 'Threat'
};
export function VirusScanStatusFromJSON(json) {
    return VirusScanStatusFromJSONTyped(json, false);
}
export function VirusScanStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function VirusScanStatusToJSON(value) {
    return value;
}
